<div class="success-full relative overflow-hidden">
    <div class="nav-actions">
        <app-lang-switcher class="white-lang-switcher"></app-lang-switcher>
        <button data-test="cop-btn-logout" class="btn btn-logout" (click)="onLogout()" translate>
            authentication.logout
        </button>
    </div>

    <section class="success pt-4">
        <h1 class="title mb-7" translate>cop.broker-helper.title</h1>

        <div class="row justify-content-center">
            <div class="col-10 no-padding d-flex">
                <finstein-search-all-table
                    class="m-auto"
                    [table]="companiesList"
                    [rows]="companies"
                    [customSearchProps]="[{ prop: 'deletedEmail' }]"
                    searchPlaceholder="cop.broker-helper.search-companies"
                ></finstein-search-all-table>
            </div>

            <div class="col-10 mt-4 no-padding employees-table-container">
                <ng-scrollbar class="employees-scrollbar">
                    <ngx-datatable
                        #companiesList
                        class="material expandable employees-datatable"
                        columnMode="force"
                        [headerHeight]="50"
                        [footerHeight]="50"
                        [rowHeight]="50"
                        [rows]="companies"
                        [loadingIndicator]="loadingEmployees"
                        [scrollbarH]="true"
                        [virtualization]="false"
                        [externalPaging]="false"
                    >
                        <ngx-datatable-column
                            [name]="'cop.broker-helper.companies.company-name' | translate"
                            prop="name"
                        ></ngx-datatable-column>
                        <ngx-datatable-column
                            [name]="'cop.broker-helper.companies.lead-name' | translate"
                            prop="leadName"
                        ></ngx-datatable-column>
                        <ngx-datatable-column
                            [name]="'cop.broker-helper.companies.tax-number' | translate"
                            prop="taxNumber"
                        ></ngx-datatable-column>
                        <ngx-datatable-column
                            [name]="'cop.broker-helper.companies.status' | translate"
                            cellClass="d-inline-flex align-items-center justify-content-center"
                            prop="status">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <finstein-datatable-status-column
                                [row]="row"
                            ></finstein-datatable-status-column>
                        </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column
                            [name]="'cop.helper.employees.actions' | translate"
                            [sortable]="true"
                            [draggable]="false"
                            [canAutoResize]="true"
                            cellClass="datatable-body-cell-buttons"
                        >
                            <ng-template
                                let-row="row"
                                ngx-datatable-cell-template
                            >
                                <button
                                    class="btn-action ml-1"
                                    (click)="onSelectCompany(row)"
                                    matRipple
                                >
                                    <i class="material-icons">visibility</i>
                                </button>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </ng-scrollbar>

                <finstein-search-column
                    [table]="companiesList"
                    [rows]="companies"
                ></finstein-search-column>
            </div>
        </div>
    </section>
</div>
